import React from 'react';
import CCTVSearchForm from './CCTVSearchForm';
import CCTVVideoRequestsTemplate from './CCTVVideoRequestsTemplate';
import { useCCTV } from './useCCTV';

export default function CCTVSearch() {
  const {
    videoRequests,
    totalCount,
    isLoading,
    error,
    queryParams,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    handleSearch,
    refreshCctvVideoRequestsTable,
    handlePageChange,
    handlePageSizeChange,
    setQuerySort,
    setQueryOrderBy,
    handleDownload,
  } = useCCTV();

  return (
    <>
      <CCTVSearchForm
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        onSearch={handleSearch}
        onVideoRequestSuccess={refreshCctvVideoRequestsTable}
      />
      <CCTVVideoRequestsTemplate
        data={{ data: videoRequests, totalCount }}
        isLoading={isLoading}
        isError={!!error}
        error={error}
        pageSize={Number(queryParams.pageSize)}
        onPageSizeChange={handlePageSizeChange}
        onPageChange={handlePageChange}
        pageNumber={Number(queryParams.pageNumber)}
        setQueryOrderBy={setQueryOrderBy}
        setQuerySort={setQuerySort}
        onDownload={handleDownload}
      />
    </>
  );
}
